<template>
  <div class="shop-container" v-loading.fullscreen="loadingShow" >
    <div class="nav-wrap">
      <div class="banner-list">
        <el-carousel arrow="never" height="440px">
          <el-carousel-item v-for="(item,index) in bannerArr" :key="index">
            <img :src="item.img" :alt="item.name" @click="swiperClick(item)" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="bgw nodata" v-if="noDataIsShow && goodsList.length == 0">
      <!-- {{$t('notFound')}} -->No result for “<span class="search-name">{{$route.query.search_name}}</span>”  Found
	  <div class="nofound">
		<p>Suggestions:</p>
		<span>• Check for misspellings.</span>
		<span>• Remove possible redundant keywords.</span>
		<span>• Use other words for describe what you are searching for.</span>
		<p>Still can't find what you're looking for?</p>
		<p>Email</p>
		<span>nathan@sanlidaarchery.com</span>
		<span>info@sanlidaarchery.com</span>
		<p>Call Us</p>
		<!-- <span>+86-15538955549</span> -->
		<span>+86-391-3216626</span>
	  </div>
    </div>

    <div class="container bgw">
      <div class="filter-box">
        <div class="filter-list-wrap" v-if="catList.length>0">
          <div class="filter-list-head">{{$t('classify')}}:</div>
          <div class="filter-list">
            <!-- <div class="filter-item active">全部</div> -->
            <div
              class="filter-item"
              v-for="(item,index) in filterClassComputed(catList,'class')"
              :key="index"
              @click="selectCat(item.goods_cat_id)"
              :class="selectedCatId==item.goods_cat_id?'active':''"
            >{{item.name}}</div>
          </div>
          <div class="more" @click="showMoreClass=!showMoreClass" v-if="catList.length>6">
            {{showMoreClass? $t('close') : $t('more')}}
            <i
              class="icon iconfont iconxjt"
              :class="{'top':showMoreClass}"
            ></i>
          </div>
        </div>
        <div class="filter-list-wrap" v-if="brandList.length>0">
          <div class="filter-list-head">{{$t('brand')}}:</div>
          <div class="filter-list">
            <div
              class="filter-item"
              v-for="(item,index) in filterClassComputed(brandList,'brand')"
              :key="index"
              @click="selectBrand(item.brand_id)"
              :class="selectedBrandId==item.brand_id?'active':''"
            >{{item.name}}</div>
          </div>
          <div class="more" v-if="brandList.length>6" @click="showMoreBrand=!showMoreBrand">
            {{showMoreBrand? $t('close') : $t('more')}}
            <i
              class="icon iconfont iconxjt"
              :class="{'top':showMoreBrand}"
            ></i>
          </div>
        </div>

        <!-- <div class="filter-list-wrap" v-if="brandList.length>0">
          <div class="filter-list-head">筛选:</div>
          <div class="filter-list">
            <div class="filter-item" v-for="(item, index) in filterArr" :key="index">
              <el-checkbox >{{item.name}}</el-checkbox>
            </div>
          </div>
          <div class="more" v-if="brandList.length>6" @click="showMoreBrand=!showMoreBrand">
            {{showMoreBrand?'收起':'更多'}}
            <i
              class="icon iconfont iconxjt"
              :class="{'top':showMoreBrand}"
            ></i>
          </div>
        </div>-->

        <div class="filter-checkbox" style="height: initial" v-if="labelList.length>0">
          <span>{{$t('filter')}}:</span>
          <el-checkbox-group v-model="checkList" @change="boxChange">
            <el-checkbox
              :label="item.id"
              :checked="checkList.includes(item.id + '')"
              v-for="(item,i) in labelList"
              :key="i"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>

          <div class="sort-box" style="padding-left: 0">
            <div class="price-wrap">
              <div class="input-wrap" style="width: 100px; margin-left: 0">
                <el-input size="small" placeholder="￥" v-model="price_f"></el-input>
              </div>-
              <div class="input-wrap" style="width: 100px">
                <el-input size="small" placeholder="￥" v-model="price_t"></el-input>
              </div>
              <!-- 搜索 -->
              <el-button size="mini" class="btn-search" @click="getGoodsList">{{$t('search')}}</el-button>
            </div>
          </div>
        </div>

        <div class="sort-box">
          <span class="sort-title">{{$t('sort')}}:</span>
          <ul class="filter-nav">
            <li :class="{'active':searchOptions.order.key=='sort'}">
              <a href="javascript:;" @click="comprehensive">{{$t('synthesize')}}</a>
            </li>
            <li :class="{'active':searchOptions.order.key=='price'}">
              <a href="javascript:;" @click="priceSort">
                {{$t('price')}}
                <i
                  class="icon iconfont"
                  :class="searchOptions.order.key=='price'&&searchOptions.order.sort=='asc'?'iconpriceup':'iconpricedown'"
                ></i>
              </a>
            </li>
            <li :class="{'active':searchOptions.order.key=='buy_count'}">
              <a href="javascript:;" @click="salesVolume">
                {{$t('sales')}}
                <i
                  class="icon iconfont"
                  :class="searchOptions.order.key=='buy_count'&&searchOptions.order.sort=='asc'?'iconpriceup':'iconpricedown'"
                ></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div>
      <ProductRowBig :list="goodsList" />
    </div>

    <!-- <template v-if="goodsList.length>0">
      <Pagination
        :totalPage="totalPage"
        :limit="searchOptions.limit"
        @changePage="handleCurrentChange"
      ></Pagination>
    </template> -->
  </div>
</template>

<script>
import ProductRowBig from "@/components/layout/ProductRowBig.vue";

import Pagination from "@/components/common/Pagination.vue";

import { deepCopy } from "@/utils";
import { goodsStyle } from "@/utils";
export default {
  name: "SearchResult",
  components: { Pagination, ProductRowBig },
  props: {},
  data() {
    return {
      showFilter: true,
      showMoreClass: false,
      showMoreBrand: false,
      checkList: [],
      catList: [], //分类
      brandList: [], //品牌
      labelList: [], //筛选标签
      goodsList: [],
      totalPage: 0,
      searchOptions: {
        where: {},
        limit: 21,
        page: 1,
        order: {
          key: "sort",
          sort: "asc" //默认综合排序
        }
      },
      price_f: "",
      price_t: "",
      bannerArr: [],
      noDataIsShow: false,
      loadingShow: false,
      firstLoad: true, //是否初次加载
      selectedCatId: "", //选择的分类ID
      selectedBrandId: "", //选择的品牌ID
      selectedlabelId: "", //选择的筛选ID
      goodsStyle: Number, // 商品列表排列方式  1：多个一行 2：一个一行
      currentNum: 1,
      loadingAjax: false,
      // loading: false
    };
  },
  watch: {
    $route(to, from) {
      const _this = this
      // if (from.name == "detail") {
      //   if(!to.query.detail) {
      //     return
      //   }
      // }
        this.searchOptions.page = 1
        setTimeout(() => {
          window.scrollTo(0, 600)
        }, 200)

      if (to.name == "search") {
        setTimeout(() => {
          let query = to.query;
          this.checkList = [];
          if (to.query.label_id) {
            if (this.checkList.includes(to.query.label_id - 0)) {
            } else {
              this.checkList.push(to.query.label_id - 0);
            }
          }
          _this.getHomeSlider();
          _this.initData(query);
        }, 800);
      }
    }
  },

  computed: {
    filterClassComputed() {
      return (list, type) => {
        if (list.length < 7) {
          return list;
        }
        if (type == "class") {
          if (this.showMoreClass) {
            return list;
          }
        }
        if (type == "brand") {
          if (this.showMoreBrand) {
            return list;
          }
        }
        return list.slice(0, 6);
      };
    }
  },
  methods: {
    handleScroll() {


      // 变量 scrollHeight 是滚动条的总高度
    let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

    // 变量 windowHeight 是可视区的高度
    let windowHeight = document.documentElement.clientHeight || document.body.clientHeight

    // 变量scrollTop为当前页面的滚动条纵坐标位置
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    // 滚动条到底部得距离 = 滚动条的总高度 - 可视区的高度 - 当前页面的滚动条纵坐标位置
    var scrollBottom = scrollHeight - windowHeight - scrollTop

    console.log(scrollBottom < 800 && !this.loadingAjax )
    if(scrollBottom < 800 && !this.loadingAjax && this.searchOptions.page <= this.totalPage && this.goodsList.length >= this.searchOptions.limit) {

      this.loadingAjax = true
      this.searchOptions.page ++
       this.setSearchOptions({
        page: this.searchOptions.page
      });
      this.getGoodsList();
    }
    // console.log(scrollBottom,'scrollBottom')    

      // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      // console.log(document.documentElement.offsetHeight, scrollTop, window.innerHeight)
      // let bottomOfWindow =  document.documentElement.offsetHeight + scrollTop - window.innerHeight <= 300
      //   if(bottomOfWindow) {
      //     let a = JSON.parse(JSON.stringify(this.goodsList))
      //     this.goodsList = this.goodsList.concat(a)
      //   }
    },

    // /点击
      swiperClick(v) {
        // type 1 url 直接跳转
        // 2 商品
        //  3 文章
        // 4  文章分类
        // 5 智能表单
      // window.open('https://www.baidu.com','_blank')
        if(v.type == 1) {
          window.open(v.val,'_blank')
          return
        }

        if(v.type == 2) {
           this.$router.push({
            name: 'detail',
            params: {goodsId: v.val}
            // path: `detail/${v.val}`,
          })
          return
        }
      },
      
    boxChange(e) {
      console.log(e);
    },
    //获取首页banner轮播
    getHomeSlider() {
      let data = {
        code: "pc_shop_home_slide"
      };

      console.log('this,,,', this.$route.query.id)

      if(this.$route.query.id) {
        data.id = this.$route.query.id
      }
       this.$api.slider(data).then(res => {
        if (res.status) {
          this.bannerArr = res.data.list;
        }
      });
    },
	facebookAddSearch(query){
		let Search = {
			search_string:query.search_name
		};
		window.fbq('track', 'Search',Search);
	},
    initData(query) {

      this.firstLoad = true;
      this.selectedCatId = "";
      this.selectedBrandId = "";
      this.selectedlabelId = "";
      let sd = this.searchOptions;
      this.searchOptions = Object.assign(sd, { where: {} });
      this.handleParamsData(query);
	  this.facebookAddSearch(query);
    },
    //搜索分类
    selectCat(id) {
      let data = {
        page: 1,
        where: {
          cat_id: id
        }
      };
      this.selectedCatId = id;
      this.setSearchOptions(data, true);
      this.getGoodsList();
    },
    //搜索品牌
    selectBrand(id) {
      let data = {
        page: 1,
        where: {
          brand_id: id
        }
      };
      this.selectedBrandId = id;
      this.setSearchOptions(data, true);
      this.getGoodsList();
    },
    selectName(name) {
      let data = {
        page: 1,
        where: {
          search_name: name
        }
      };
      this.setSearchOptions(data, true);
      this.getGoodsList();
    },
    //筛选条件参数处理
    conditions() {
      if (this.price_f > 0 || this.price_t > 0) {
        this.searchOptions.where.price_f = this.price_f;
        this.searchOptions.where.price_t = this.price_t;
      } else {
        this.searchOptions.where.price_f &&
          delete this.searchOptions.where.price_f;
        this.searchOptions.where.price_t &&
          delete this.searchOptions.where.price_t;
      }

      if (this.$route.query && this.$route.query.label_id) {
        if (
          this.checkList.includes(this.$route.query.label_id + "") ||
          this.checkList.includes(this.$route.query.label_id)
        ) {
        } else {
          //console.log("dfsaf------push------");
          // this.checkList.push(this.$route.query.label_id - 0);
        }
      }
      if (this.checkList.length > 0) {
        this.searchOptions.where.label_id = this.checkList.join(",");
      } else {
        this.searchOptions.where.label_id &&
          delete this.searchOptions.where.label_id;
      }

      // console.log(' this.searchOptions',  this.searchOptions)
      // if(this.$route.query && this.$route.query.label_id) {
      //   this.searchOptions.where.label_id = this.$route.query.label_id
      // } else{
      //   this.searchOptions.where.label_id && delete this.searchOptions.where.label_id
      // }

      let data = this.searchOptions;
      var newData = {};
      newData = deepCopy(newData, data);
      //把data里的where换成json
      if (data.where) {
        newData.where = JSON.stringify(data.where);
      }
      //把排序换成字符串
      if (data.order) {
        var sort = data.order.key + " " + data.order.sort;
        if (data.order.key != "sort") {
          sort = sort + ",sort asc"; //如果不是综合排序，增加上第二个排序优先级排序
        }
        newData.order = sort;
      } else {
        newData.order = "sort desc";
      }

      return newData;
    },
    handleParamsData(query) {
      console.log("query", query);
      let where = {};
      if (query.key) {
        where = { search_name: query.key };
      }
      if (query.id) {
        where = {
          cat_id: query.id
        };
      }
      if (query.type) {
        if (query.type == "hot") {
          where = {
            hot: true
          };
        }
        if (query.type == "recommend") {
          where = {
            recommend: true
          };
        }
      }

      if (query.label_id) {
        // where.label_id = query.label_id;
      }

      this.setSearchOptions({ where: where });
      this.getGoodsList();
    },
    //点击综合排序
    comprehensive: function() {
      this.setSearchOptions(
        {
          order: {
            key: "sort",
            sort: "asc"
          },
          page: 1
        },
        true
      );
      this.getGoodsList();
    },
    //销量排序
    salesVolume: function() {
      let sort = "asc";
      if (this.searchOptions.order.key == "buy_count") {
        if (this.searchOptions.order.sort == "desc") {
          sort = "asc";
        } else {
          sort = "desc";
        }
      }
      this.setSearchOptions(
        {
          order: {
            key: "buy_count",
            sort: sort
          },
          page: 1
        },
        true
      );
      this.getGoodsList();
    },
    //价格排序
    priceSort: function() {
      let sort = "asc";
      if (this.searchOptions.order.key == "price") {
        if (this.searchOptions.order.sort == "desc") {
          sort = "asc";
        } else {
          sort = "desc";
        }
      }
      this.setSearchOptions(
        {
          order: {
            key: "price",
            sort: sort
          },
          page: 1
        },
        true
      );
      this.getGoodsList();
    },

    //获取商品列表
    getGoodsList() {

      let obj = this.conditions();
      this.loadingShow = true;
      this.$api.goodsList(obj).then(res => {

        setTimeout(() => {
          this.loadingAjax = false
        }, 2000)
        if (res.status) {
          this.totalPage = res.data.total_page;
          this.showFilter = this.goodsList.length > 0 ? true : false;
          let filter = res.data.filter;
          if (this.firstLoad) {
            this.firstLoad = false;
            this.catList = filter.goods_cat ? filter.goods_cat : [];

            // console.log(' this.catList',  this.catList)
            this.brandList = filter.brand_ids ? filter.brand_ids : [];
            this.labelList = filter.label_ids ? filter.label_ids : [];
            this.goodsList = res.data.list;

          } else {
          this.goodsList = this.goodsList.concat(res.data.list) ;

          }
          if (res.data.list.length == 0) {
            this.noDataIsShow = true;
          } else {
            this.noDataIsShow = false;
          }
        }
        this.loadingShow = false;
      });
    },
    //设置筛选条件
    setSearchOptions: function(searchData, clear = false) {
      var sd = this.searchOptions;
      this.searchOptions = deepCopy(sd, searchData);
      if (clear) {
        this.goodsList = [];
      }
    },
    //分页
    handleCurrentChange(val) {
      // window.scroll
      document.body.scrollTop = document.documentElement.scrollTop = 700;
      this.setSearchOptions({
        page: val
      });
      this.getGoodsList();
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll',this.handleScroll)
  },
  mounted() {
    window.addEventListener('scroll',this.handleScroll)
  },
  created() {
    let query = this.$route.query;
    this.goodsStyle = goodsStyle;
    this.checkList = [];
    if (this.$route.query.label_id) {
      this.checkList.push(this.$route.query.label_id - 0);
    }

    console.log("uery.search_name", query.search_name);
    // if(query.search_name) {
    // this.id = ''
    // this.selectName(query.search_name)
    // } else{
    this.handleParamsData(query);
    // }
    this.getHomeSlider();
	this.facebookAddSearch(query);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.btn-search {
  background: #e6442f;
  color: #fff;
}
.shop-container {
  margin-bottom: 20px;
  .nav {
    @include line-height(40px);
    font-size: 12px;
    span {
      padding: 0 3px;
      font-size: #757575;
    }
    a:hover {
      color: #000;
    }
  }
  .nodata {
    height: 370px;
    line-height: 40px;
    margin-bottom: 10px;
    padding-left: 14px;
    font-weight: bold;
    background: #ffffff;
    border: 1px solid #edd28b;
    .search-name {
      color: $theme-color;
    }
	.nofound{
		p{line-height: 30px;}
		span{
			padding-left:15px;
			line-height: 22px;
			margin-bottom: 5px;
			font-weight: normal;
			display: block;
		}
	}
  }
  .container {
    background: #fff;
    padding: 4px 18px;
    margin: 20px 0;
    .filter-box {
      margin: 0 auto;
      font-size: 14px;
      .filter-list-wrap {
        position: relative;
        padding-left: 72px;
        transition: height 0.25s linear;
        border-bottom: 1px dashed $border;
        &.open {
          .filter-list {
            height: 120px;
          }
        }
        .filter-list-head {
          width: 72px;
          position: absolute;
          left: 0;
          top: 14px;
          color: #b0b0b0;
        }
        .filter-list {
          display: flex;
          flex-flow: row wrap;
          padding-right: 60px;
          .filter-item {
            min-width: 150px;
            height: 20px;
            line-height: 20px;
            padding: 12px 0;
            cursor: pointer;
            padding-right: 30px;
            &.active {
              color: $theme-color;
            }
          }
        }
        .more {
          position: absolute;
          right: 0;
          top: 8px;
          height: 24px;
          line-height: 24px;
          color: #757575;
          cursor: pointer;
          user-select: none;
          &:hover {
            color: $theme-color;
          }
          .icon {
            display: inline-block;
            transition: all 0.2s;
            &.top {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }
  .sort-box {
    position: relative;
    padding-left: 72px;
    display: flex;
    .sort-title {
      position: absolute;
      top: 0;
      left: 0;
      height: 45px;
      line-height: 45px;
      color: #b0b0b0;
    }
    .price-wrap {
      display: flex;
      align-items: center;
      .input-wrap {
        margin: 0 10px;
      }
      .el-button {
        margin-left: 10px;
      }
    }
  }
  .filter-nav {
    height: 45px;
    display: flex;
    align-items: center;
    li {
      padding: 0 30px;
      font-size: 14px;
      border-right: 1px solid $border;
      &:last-of-type {
        border: none;
      }
      &:hover {
        color: $theme-color;
        .icon {
          color: $theme-color;
        }
      }
      a {
        display: block;
      }
      &.active {
        color: $theme-color;
        .icon {
          color: $theme-color;
        }
      }
      &:first-of-type {
        padding-left: 0;
        padding-right: 30px;
      }
      .icon {
        color: #333;
        font-size: 14px;
      }
    }
    .sort-title {
      margin-right: 40px;
    }
  }
  .filter-checkbox {
    height: 45px;
    line-height: 45px;
    position: relative;
    padding-left: 72px;
    border-top: 1px dashed $border;
    span {
      position: absolute;
      left: 0;
      top: 0;
      color: #b0b0b0;
    }
  }
}

// 轮播图
.nav-wrap {
  width: 100%;
  position: relative;
  height: 440px;

  .banner-list {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 440px;
    z-index: 10;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>